const encoder = new TextDecoder()

/**
 * Converts a Uint8Array to a string using UTF-8 decoding.
 *
 * @param value - The Uint8Array to decode
 * @returns The decoded string
 *
 * @example
 * ```ts
 * import { Uint8ToString } from "@pdfking/tfunc"
 *
 * const bytes = new Uint8Array([72, 101, 108, 108, 111]);
 * const text = UInt8ToString(bytes);
 * console.log(text); // "Hello"
 *
 * // Round-trip conversion
 * const original = "Hello, World!";
 * const decoded = UInt8ToString(StringToUInt8(original));
 * console.log(decoded === original); // true
 * ```
 */
export const UInt8ToString = (value: Uint8Array): string =>
  encoder.decode(value)
